export const parkingCompanyOfAmericaStyles = {
	header: {
		backgroundColor: '#161616',
	},
	sidebar: {
		backgroundColor: '#161616',
		color: 'white',
	},
	button: {
		backgroundColor: '#fe0000',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#fe0000',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#161616',
		buttonLoadingColor: '#ff4141ff',
	},
	table: {
		headerBackgroundColor: '#0166ff',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking Company of America Platform',
	},
	logo: {
		small: {
			src: '/parkingCompanyOfAmerica/pca-logo.png',
			height: 60,
			width: 40,
		},
		large: {
			src: '/parkingCompanyOfAmerica/pca-logo.png',
			height: 60,
			width: 100,
		},
	},
	favicon: {
		src: '/parkingCompanyOfAmerica/pca-logo.png',
	},
	socials: {
		instagram: 'https://instagram.com/pcaparking',
		x: 'https://x.com/parkpca',
		facebook: 'https://www.facebook.com/parkpca',
		linkedIn: 'https://www.linkedin.com/company/parkpca',
		youtube: 'https://www.youtube.com/@parkpca',
	},
	siteUrl: 'https://parkwithpca.com/',
	orgName: 'Parking Company Of America',
};
